const min = 10000;
  const max = 99999;
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

  const sessionTime = Date.now();
  const sessionId = sessionTime + "" + randomNumber;
  if(!sessionStorage.getItem("sessionId")){
     sessionStorage.setItem("sessionId", sessionId);
  }
 

const getHeaders = () => {
  const fragment = window.location.search;
  const queryParams = fragment.split('?')[1];
  const params = new URLSearchParams(queryParams);
  const camp = params.get("camp");
  const rcid = params.get("rcid");

  

  return {
    'Servicefor': 'mtn_mu',
    'Username': 'web',
    'Language': localStorage.getItem("appLang") || "fr",
    'opco': "evina",
    "camp": camp || localStorage.getItem("camp"),
    "rcid": rcid || localStorage.getItem("rcid"),
    "blocked": "0",
    "breason": "",
    "sid": sessionStorage.getItem("sessionId") || sessionId,
    "flow": localStorage.getItem("mtype") || "",
    "w_req_url": window.location.href,
    "msisdn": localStorage.getItem("msisdn") || localStorage.getItem("msisdn2")
  };
};


let data = {
    "calling_code": "Ghana",
    "msisdn": localStorage.getItem("msisdn") ? localStorage.getItem("msisdn") : localStorage.getItem("msisdn2")

}


const baseUrl = 'https://sandboxapisv1.bngrenew.com/mtnghana_lite/apn/'
const elastic_base_url = "https://serviceusagesv1.bngrenew.com/publish"



export {getHeaders , data , baseUrl,elastic_base_url}